const AvatarUser = ({ firstName, lastName, bigger, borders }) => {
  return (
    <div
      className={
        'text-white bg-primary rounded-full font-medium flex items-center justify-center text-sm uppercase ' +
        (bigger
          ? ' h-[54px] w-[54px] min-w-[54px]'
          : ' min-w-[36px] w-[36px] h-[36px] ') +
        (borders ? ' border-2 border-white' : '')
      }
    >
      {firstName?.substring(0, 1)}
      {lastName?.substring(0, 1)}
    </div>
  )
}

export default AvatarUser
